import { Component } from '@angular/core';
declare var jQuery:any
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  ngAfterViewInit(){
      jQuery(function($) {
        jQuery("img").Lazy();
      });
  }
}
